// 鉴权相关常量
export const AUTH_CONFIG = {
    APP_ID: 'app1',
    APP_KEY: 'your-secure-app-key-1'  // 在实际应用中，应该使用环境变量存储这些敏感信息
};

export const prodBaseUrl = 'https://server.love-study.tech/api';

// API URL配置 - 根据环境变量自动选择
export const API_CONFIG = {
    BASE_URL : process.env.REACT_APP_BASE_URL || prodBaseUrl,
};

// 定义全局网络常量
export const BUSINESS_STATUS_CODE = {
  SUCCESS: 200,
  NOT_FOUND: 404,
  SERVER_ERROR: 500
};
